import React, { useCallback, useEffect, useState } from "react";

import styles from "./UserAvatar.module.css";

export type UserAvatarProps = {
	/** Caller-supplied class carrying the size, border, and background of the chip. */
	className?: string;
	/** Shown when set; the initials render otherwise. */
	imageUrl?: string | null;
	initials: string;
	title?: string;
};

/** A user avatar chip: the profile photo when one is set, the user's initials otherwise. */
export const UserAvatar = ({ className, imageUrl, initials, title }: UserAvatarProps) => {
	// A broken/blocked image URL falls back to initials instead of an invisible broken <img>.
	const [imageFailed, setImageFailed] = useState(false);
	useEffect(() => {
		setImageFailed(false);
	}, [imageUrl]);
	const onImageError = useCallback((): void => setImageFailed(true), []);

	return (
		<span aria-hidden="true" className={`${styles.avatar} ${className ?? ""}`} title={title}>
			{imageUrl && !imageFailed ? (
				// Google-hosted photos (lh3.googleusercontent.com) intermittently reject requests
				// that carry a Referer header, so avatars always load without one.
				<img alt="" onError={onImageError} referrerPolicy="no-referrer" src={imageUrl} />
			) : (
				initials
			)}
		</span>
	);
};
